import React, { useContext } from 'react';
import { css } from '@emotion/react';
import CardMain from '../cards/CardMain';
import { OverlayComponentProps } from '../InteractionInfo';
import { usePropertyFilledLink } from '$/components/ui/EditableInput/DangerouslySetInnerHTML';
import { FormOptionsContext } from '$/components/ui/Form';
import { useWebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { InteractionType, RoomType } from '$/GraphQL/schema/types';

const OfferOverlayButton: React.FC<OverlayComponentProps> = ({ interaction }) => {
  const { onSubmit } = useContext(FormOptionsContext);
  const { playbackPosition, currentRoom, mode, interactions } = useWebinarPlayerContext();

  const detailLink = usePropertyFilledLink(interaction.details?.link);

  if (
    currentRoom.type != RoomType.Presentation ||
    interaction.isExpired(playbackPosition, mode) ||
    playbackPosition < interaction.playbackPosition
  )
    return null;

  const overridingCurrentButton = interactions.find(
    (i) =>
      i.id != interaction.id &&
      i.type == InteractionType.SpecialOffer &&
      i.fragment.details?.showOverlayButton &&
      i.playbackPosition <= playbackPosition &&
      i.playbackPosition >= interaction.playbackPosition &&
      !i.isExpired(playbackPosition, mode)
  );

  if (overridingCurrentButton) return null;

  return (
    <div
      css={css`
        position: absolute !important;
        pointer-events: auto;
        top: 2%;
        right: 2%;
      `}
    >
      <CardMain.SubmitButton
        className='control mt-0 py-1/2e px-3e text-2xl font-semibold'
        css={css`
          transform-origin: top right;
        `}
        dontCenter
        onClick={(): void => {
          if (detailLink) {
            window.open(detailLink, '_blank');
          }
          onSubmit();
        }}
      >
        {interaction.fragment.details?.overlayButtonText ?? 'Claim'}
      </CardMain.SubmitButton>
    </div>
  );
};

export default OfferOverlayButton;
